import {createTooltipTranslationProviderFromNamespace} from 'features/localizedTooltips';

export const DashboardTooltipTranslationProvider =
	createTooltipTranslationProviderFromNamespace('features/dashboard');
